export const fileSave = (data: Blob, fileName: string) => {
  const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}